export const BASE_URL = process.env.REACT_APP_BASE_API_URL;
export const BASE_AUTH = process.env.REACT_APP_BASIC_AUTH;

export const IS_LOCAL = process.env.REACT_APP_CUSTOM_NODE_LOCAL === "local";
